// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper--EJdNI605ub02ceyu"};